import * as React from 'react';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Tooltip from '@material-ui/core/Tooltip';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { DotBadge } from '../DotBadge';
import { ListItem } from './ListItem';
import { ListItemIcon } from './ListItemIcon';
import { ListItemText } from './ListItemText';

const styles = (theme: Theme) =>
  createStyles({
    subheader: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium
    },
    boldSubheader: {
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightBold
    },
    expand: {
      color: theme.palette.text.secondary
    },
    container: {
      '& li': {
        overflowX: 'hidden',
        whiteSpace: 'nowrap'
      }
    },
    entered: {
      '& li': {
        whiteSpace: 'normal'
      }
    }
  });

type OwnProps = {
  handleExpand: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  subheader: string;
  icon: JSX.Element;
  expanded: boolean;
  navExpanded: boolean;
  showDotBadge?: boolean;
  tooltip?: boolean;
  isBold?: boolean;
};

type Props = WithStyles<typeof styles> & OwnProps;

const Section: React.FC<Props> = ({
  handleExpand,
  subheader,
  icon,
  expanded,
  navExpanded,
  showDotBadge,
  tooltip,
  isBold,
  classes,
  children
}) => {
  const displayIcon = showDotBadge ? <DotBadge>{icon}</DotBadge> : icon;

  const listItem = (
    <ListItem button onClick={handleExpand}>
      <ListItemIcon>{displayIcon}</ListItemIcon>
      <ListItemText
        primaryTypographyProps={{
          className: `${classes.subheader} ${isBold ? classes.boldSubheader : null}`,
          noWrap: true
        }}
      >
        {subheader}
      </ListItemText>
      {expanded ? <ExpandLess className={classes.expand} /> : <ExpandMore className={classes.expand} />}
    </ListItem>
  );

  return (
    <React.Fragment>
      {navExpanded && !tooltip ? (
        listItem
      ) : (
        <Tooltip title={subheader} placement="right">
          {listItem}
        </Tooltip>
      )}
      <Collapse
        in={expanded}
        classes={{
          container: classes.container,
          entered: classes.entered
        }}
      >
        {children}
      </Collapse>
      <Divider />
    </React.Fragment>
  );
};

export const SectionComponent = withStyles(styles)(Section);
